import React from 'react';
import {useState} from 'react';
import './portfolioHeader.css';

import headerBg from '../../assets/portfolio/header-background.svg';
import headerLogo from '../../assets/portfolio/header-logo.svg';

function PortfolioHeader() {

    const [toggled, setToggled] = useState(false);

    const handleToggle = () => {
        setToggled(!toggled);
        if (!toggled) {
            window.location.href = "mailto:allyjmccann@gmail.com";
        }
    };

    return (
        <div className='portfolioHeader-container'>
            <img
                src={headerBg}
                alt="Header background"
                className="portfolioHeader-bg"
            />
            <section>
                <nav>
                    <ul className='portfolio-nav'>
                        <li><a href="#aboutMe">About Me</a></li>
                        <li><a href="#projects">Projects</a></li>
                    </ul>
                </nav>
            </section>
            <section>
                <img className='portfolioHeader-image' src={headerLogo}
                alt='Header Title' />
            </section>
            <section className='portfolioContact-button'>
                <button 
                    type="button" 
                    className="contact-btn"
                    onClick={handleToggle}
                >
                    <div className={`switch ${toggled ? 'on' : ''}`}>
                        <div className="knob"></div>
                    </div>
                    <span className="btn-text">Get in Touch</span>
                </button>
            </section>
        </div>
    )
}

export default PortfolioHeader
